export const MONEY_DECIMAL_PLACES = 10;
export const DECIMAL_PLACES = 10;
export const MONEY_SYMBOL = '₫';
export const MONEY_LOCALE = 'vi-VN';

// Feeds the `ccurrency` pipe for read-only money display
export const MONEY_DISPLAY_FORMAT = {
  maxDecimalPlaces: MONEY_DECIMAL_PLACES,
  locale: MONEY_LOCALE as 'vi-VN' | 'en-US',
  thousandsSeparator: '.',
  decimalSeparator: ','
};

// Feeds editable p-inputNumber money fields so their grouping/decimal separators match MONEY_DISPLAY_FORMAT
export const MONEY_INPUT_FORMAT = {
  locale: MONEY_LOCALE,
  suffix: ` ${MONEY_SYMBOL}`,
  maxFractionDigits: MONEY_DECIMAL_PLACES
};

// Amounts are stored with the same precision the inputs accept, so sums never drift on float noise
export function roundMoney(value: number): number {
  if (!isFinite(value)) return 0;

  const factor = 10 ** MONEY_DECIMAL_PLACES;
  return Math.round(value * factor) / factor;
}
